import { ChangeDetectionStrategy, Component, computed, effect, inject } from '@angular/core';
import { RouteDaysComponent } from '../../../../shared/planner/shared/route-days/route-days.component';
import { MoreComponent } from './components/more/more.component';
import { ChatbotCustomRouteDesktopComponent } from "./components/chatbot-custom-route-desktop/chatbot-custom-route-desktop.component";
import { ChatBotScriptService } from 'src/app/services/chatbot.service';
import { EditRouteService } from 'src/app/pages/custom-route/shared/planner/components/edit-route/services';

@Component({
  selector: 'app-actions-footer-bar',
  standalone: true,
  imports: [
    RouteDaysComponent,
    MoreComponent,
    ChatbotCustomRouteDesktopComponent
],
  templateUrl: './actions-footer-bar.component.html',
  styleUrls: ['./actions-footer-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActionsFooterBarComponent {
  private _chatbotScriptService = inject(ChatBotScriptService);
  private _editRouteService = inject(EditRouteService);
  
  private isLoadingResourcesByIdOnEmptySpace = computed(() => this._editRouteService.isLoadingResourcesByIdOnEmptySpace());
  private isLoadingResourcesOnExistingItem = computed(() => this._editRouteService.isLoadingResourcesOnExistingItem());
  public checkIfLoadingNewResources = computed(() => this.isLoadingResourcesByIdOnEmptySpace() !== null || this.isLoadingResourcesOnExistingItem());

  protected chatId = this._chatbotScriptService.chatId;
  
  logChatId = effect(() => {
    console.log('Chat ID changed:', this.chatId());
  }, { allowSignalWrites: true });
}
